export enum UpdateOffersStatusEnum {
  Started = 'started',
  Finished = 'finished',
  Error = 'error'
}



// WEBPACK FOOTER //
// ./src/app/enums/update-offers-status.enum.ts